<template>
	<div>
		<v-layout wrap cyan body-2 font-weight-bold white--text>
			<slot></slot>
		</v-layout>
	</div>
</template>

<script>
	export default {
		name: 'header-content',
	};
</script>



// WEBPACK FOOTER //
// src/components/shared/header-content.vue